import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";
import { ICONEX, CLASS_TYPE_ICON, GBET_LOGO } from "src/constants/images";
import { MARKET_PLACE, PROFILE } from "src/constants/routes";
import collections1 from "assets/images/gangstabet-collections-1.png";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { nFormatter } from "utils/nFormatter";
import { levelDifferentiator } from "utils/levelDifferentiator";
import moment from "moment";

import bold from "../../assets/images/ic_baseline-bolt.png";
import SkeletonElement from "components/Loader/Skeleton/BasicSkeleton/SkeletonElement";

const GangstaCard = ({
  image,
  number,
  stats,
  class_type,
  type,
  token,
  name,
  data,
  id,
  for_sale,
  isGangster,
  createdAt,
  selling_price,
  totalPrice,
  accumulatedGBET,
  isAccumulatedGBETLoading,
  lastClaimTimer,
  ownerAccount,
  fromWallet,
}) => {
  const [minted_ago, setMintedAgo] = useState("");

  useEffect(() => {
    if (createdAt) {
      const current_time_utc = moment.utc();
      const difference_in_min = current_time_utc.diff(createdAt, "minute");

      if (difference_in_min <= 0) {
        setMintedAgo("few seconds");
      } else if (difference_in_min < 60) {
        setMintedAgo(
          difference_in_min + (difference_in_min == 1 ? " min" : " mins")
        );
      } else {
        const difference_in_hours = current_time_utc.diff(createdAt, "hours");

        if (difference_in_hours < 24) {
          setMintedAgo(
            difference_in_hours + (difference_in_hours == 1 ? "hour" : " hours")
          );
        } else {
          setMintedAgo(current_time_utc.diff(createdAt, "days") + " day");
        }
      }
    }
  }, []);

  const navigate = useNavigate();

  const clickHandler = (e) => {
    console.log(window.location.protocol, window.location.host);
    if (e.target.classList.value.toString().includes("class-type")) {
      navigate(`${MARKET_PLACE.INDEX}?class_type=${class_type}`);
      window.location.reload();
    } else {
      const route = PROFILE.addSlug(PROFILE.INDEX, parseInt(id));
      navigate(route);
    }
  };
  useEffect(() => {
    console.log(lastClaimTimer);
  }, [lastClaimTimer]);
  return (
    <NavLink
      to={`/profile/${parseInt(id)}`}
      tabIndex={0}
      role="button"
      onClick={clickHandler}
      className={`${class_type?.toLowerCase()} gangsta-card`}
    >
      <div className="nft-image-block position-relative">
        <img
          to={`${window.location.protocol}//${window.location.host
            }/profile/${parseInt(id)}`}
          src={image}
          alt="background"
        // onContextMenu={(e) => {
        //   e.preventDefault();
        // }}
        />

        <div class="spinner-border position-absolute spinner" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div className="gangsta-card-body">
        <NavLink className="row1" to={`/profile/${parseInt(id)}`}>
          <div className="g-name">
            <div className="name-text">
              {name ? name : `Gangstabet #${parseInt(id, 16)}`}
            </div>
          </div>
          <div className="gangsta-skill-stat d-flex">
            <div className="type-tt hover-text">
              Statistics: {stats != 0 ? parseInt(stats) : "0"}
            </div>
            <div className="skill-text">
              <img src={bold} />
            </div>

            <div className="skill-stat-value">
              {stats != 0 ? parseInt(stats) : "0"}
            </div>
          </div>
        </NavLink>
        <NavLink to={`/profile/${parseInt(id)}`} className="row2">
          <div className="badge-type ">
            <div className="d-flex">
              <div className="gangsta-type-icon">
                <div className="type-tt hover-text">
                  {isGangster != undefined
                    ? isGangster == "0x1"
                      ? `Gangsta`
                      : `Detective`
                    : ""}
                  {type !== undefined ? type : ""}
                </div>
                <div className="gangsta-type">
                  {isGangster != undefined ? (
                    isGangster == "0x1" ? (
                      <img src={CLASS_TYPE_ICON.GANGSTER} />
                    ) : (
                      <img src={CLASS_TYPE_ICON.DETECTIVE} />
                    )
                  ) : (
                    ""
                  )}
                  {type !== undefined ? (
                    type.toLowerCase() == "gangster" ? (
                      <img src={CLASS_TYPE_ICON.GANGSTER} />
                    ) : (
                      <img src={CLASS_TYPE_ICON.DETECTIVE} />
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <NavLink
                to={`/${MARKET_PLACE.INDEX}?class_type=${class_type}`}
                className={`class-type gangsta-class-type ${class_type?.toLowerCase()}`}
              >
                {class_type}
              </NavLink>
            </div>

            <div className="level-name">
              {levelDifferentiator(
                parseInt(stats),
                type !== undefined
                  ? type.toLowerCase() == "gangster"
                    ? true
                    : false
                  : isGangster != undefined
                    ? isGangster == "0x1"
                      ? true
                      : false
                    : false
              )}
            </div>
          </div>
        </NavLink>
        <NavLink className="row3" to={`/profile/${parseInt(id)}`}>
          <div className="gangsta-accumulated-gbet">
            {!isAccumulatedGBETLoading && accumulatedGBET ? (
              <div className="gangsta-price d-flex">
                <div className="type-tt hover-text">Accumulated $GBET</div>
                <img src={GBET_LOGO.SOURCE} />
                <div className="gbet-value">
                  {fromWallet
                    ? nFormatter(accumulatedGBET)
                    : nFormatter(accumulatedGBET[number])}
                </div>
                <div className="gbet-unit">$GBET</div>
              </div>
            ) : isAccumulatedGBETLoading ? (
              <div style={{ width: "80px", height: "18px" }}>
                <SkeletonElement type="box" />
              </div>
            ) : (
              <div className="filer"></div>
            )}
          </div>
          <div className="gangsta-sale">
            {for_sale ? (
              <div className="gangsta-price d-flex">
                {/* <div className="dot">&#183;</div> */}
                <div className="type-tt hover-text">Price</div>
                {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    stroke-linejoin="round"
                    stroke-miterlimit="2"
                  >
                    <g transform="translate(-135)" fill="#2ca9b7">
                      <path
                        d="M233.5 31.4l-13 13c2.8 4.6 4.4 9.9 4.4 15.7 0 16.6-13.4 30-30 30-5.7 0-11.1-1.6-15.7-4.4l-13 13c8 5.9 17.9 9.5 28.6 9.5 26.5 0 48-21.5 48-48 .2-10.9-3.3-20.8-9.3-28.8zM165 60c0-16.6 13.4-30 30-30 5.7 0 11.1 1.6 15.7 4.4l13-13c-8-5.9-17.9-9.5-28.6-9.5-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.5 28.6l13-13c-3-4.4-4.6-9.8-4.6-15.5z"
                        fill-rule="nonzero"
                      />
                      <circle cx="243" cy="12" r="12" />
                      <circle cx="147" cy="108" r="12" />
                    </g>
                  </svg>
                }
                <div className="price-value">
                  {nFormatter(
                    Number(selling_price) === selling_price &&
                      selling_price % 1 !== 0
                      ? selling_price.toFixed(2)
                      : selling_price
                  )}
                </div>
                <div className="price-unit">ICX</div>
              </div>
            ) : !totalPrice ? (
              // <div className="nfs">Not for sale</div>
              <div className="filer"></div>
            ) : (
              <div className="filer"></div>
            )}
            {totalPrice ? (
              <div className="gangsta-price d-flex">
                {/* <div className="dot">&#183;</div> */}
                <div className="type-tt hover-text">Price</div>
                {
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    stroke-linejoin="round"
                    stroke-miterlimit="2"
                  >
                    <g transform="translate(-135)" fill="#2ca9b7">
                      <path
                        d="M233.5 31.4l-13 13c2.8 4.6 4.4 9.9 4.4 15.7 0 16.6-13.4 30-30 30-5.7 0-11.1-1.6-15.7-4.4l-13 13c8 5.9 17.9 9.5 28.6 9.5 26.5 0 48-21.5 48-48 .2-10.9-3.3-20.8-9.3-28.8zM165 60c0-16.6 13.4-30 30-30 5.7 0 11.1 1.6 15.7 4.4l13-13c-8-5.9-17.9-9.5-28.6-9.5-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.5 28.6l13-13c-3-4.4-4.6-9.8-4.6-15.5z"
                        fill-rule="nonzero"
                      />
                      <circle cx="243" cy="12" r="12" />
                      <circle cx="147" cy="108" r="12" />
                    </g>
                  </svg>
                }
                <div className="price-value">{nFormatter(totalPrice)}</div>
                <div className="price-unit">ICX</div>
              </div>
            ) : (
              ""
            )}
            {ownerAccount ? (
              <div className="claimTimerCountdown">
                {lastClaimTimer ? lastClaimTimer[number]?.timeRemaining : null}
              </div>
            ) : null}
          </div>
        </NavLink>
      </div>
    </NavLink>
  );
};

export default React.memo(GangstaCard);

GangstaCard.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  class_type: PropTypes.string,
  stats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  image: PropTypes.any,
};

GangstaCard.defaultProps = {
  number: "#2090",
  type: undefined,
  stats: 0,
  class_type: undefined,
  token: 0,
  image: collections1,
};
